module.exports = {
          srcSet: "/_next/static/images/user4-146-5607cafbd8ded063c8665cfba5e5d72b.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user4-146-5607cafbd8ded063c8665cfba5e5d72b.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user4-146-5607cafbd8ded063c8665cfba5e5d72b.jpg",
          toString:function(){return "/_next/static/images/user4-146-5607cafbd8ded063c8665cfba5e5d72b.jpg"},
          
          width: 146,
          height: 146
        }